'use client';

import Link from 'next/link';

export default function NotFound() {
  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-gray-50 px-4">
      <div className="text-center">
        <h2 className="mb-4 text-3xl font-bold text-gray-900">404 - Seite nicht gefunden</h2>
        <p className="mb-6 text-lg text-gray-600">
          Die von Ihnen gesuchte Seite existiert nicht oder wurde verschoben.
        </p>
        <Link
          href="/"
          className="rounded-md bg-gray-950 px-4 py-2 text-white hover:bg-gray-800 focus:outline-none focus:ring-2 focus:ring-gray-950 focus:ring-offset-2"
        >
          Zurück zur Startseite
        </Link>
      </div>
    </div>
  );
}
